import { render, staticRenderFns } from "./simOpenXc.vue?vue&type=template&id=22de0cbe&scoped=true&"
import script from "./simOpenXc.vue?vue&type=script&lang=js&"
export * from "./simOpenXc.vue?vue&type=script&lang=js&"
import style0 from "./simOpenXc.vue?vue&type=style&index=0&id=22de0cbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de0cbe",
  null
  
)

export default component.exports